module.exports = __webpack_public_path__ + "img/1792493118604.9755077b.png";